import { Injectable, inject } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class SvgService {
    private http = inject(HttpClient);

    private static cache = new Map<string, Observable<SVGElement>>();

    // get a SVGElement wrapped in an Observable
    public getSVG( url: string ): Observable<SVGElement> {
        if ( SvgService.cache.has( url ) ) {
            // svg is in cache -> load it from cache
            return SvgService.cache.get( url );
        } else {
            // svg is not in cache -> load it from url
            let req = this.loadSVG( url );
            SvgService.cache.set( url, req );
            return req;
        }
    }

    // loads an SVG file from an URL
    private loadSVG( url: string ): Observable<SVGElement> {
        let obs = new BehaviorSubject( null );
        this.http.get( url, { responseType: 'text' } ).subscribe( (svgText: string) => {
            let svg = this.svgElementFromString( svgText );
            obs.next( svg );
        } );
        return obs;
    }

    // converts textcontent of a SVG file to a SVGElement
    private svgElementFromString( str: string ): SVGElement | never {
        const div: HTMLElement = document.createElement( 'div' );
        div.innerHTML = str;

        const svg = div.querySelector( 'svg' ) as SVGElement;

        if ( !svg ) {
            throw new Error( 'Cannot parse SVG-Element from string' );
        }

        return svg;
    }
}
